import services from '../services'
import { reactive } from 'vue'

export default function () {

    const state = reactive({
        bilhete: {},
        pesquisarCartela:'',

        loading:{
           carregarCartela: false
        },

        errorMessage: null
    })


    // A pesquisa aceita tanto o token do bilhete compartilhado quanto o id de uma cartela
    async function carregarCartelas() {

        state.loading.carregarCartela = true

        let token = state.pesquisarCartela.trim()

        try {
            const response = await services.cartelas.getAll({token})
            state.bilhete = response.data
            state.errorMessage = null
        }
        catch (e) {
            state.bilhete = {}

            const resposta = e.response ? e.response.data : null

            // A API responde com o motivo, como cartela não encontrada ou sorteio ainda não finalizado
            state.errorMessage = resposta && resposta.message
                ? resposta.message
                : "Não foi possível carregar as cartelas."
        }
        finally{
            state.loading.carregarCartela = false
        }
    }

    return {
        stateCartelas: state,
        carregarCartelas,
    }
}
